import React from 'react'
import { ReactComponent as FullLogo } from '../assets/svg/full_logo.svg'
import AppImage from '../assets/images/app_image.png'
import { ReactComponent as AppStore } from '../assets/images/app-store.svg'
import { ReactComponent as GooglePlay } from '../assets/images/google-play.svg'
import useLocale from '../locales'

const AppPromo = ({ className = "" }) => {
    const { textData } = useLocale()
    return (
        <div className={`${className} from-[#07B5B5] to-[#058282] bg-gradient-to-b rounded-lg p-[18px] w-[284px]`}>
            <FullLogo />
            <div className='flex justify-between mt-4 gap-6'>
                <div className='flex flex-col justify-between'>
                    <p className='text-base font-bold text-white mt-2.5 leading-tight'>
                        <span className='text-[#FFCB52]'>
                            {textData.appPromo?.getOurApp || 'Get our App'}
                        </span>
                        {' '}{textData.appPromo?.tagline || 'for quick financial planning on the go.'}
                    </p>
                    <div className='flex gap-1.5 mt-auto'>
                        <AppStore width={60} height={22} className='w-[60px] cursor-pointer' onClick={() => window.open('https://apps.apple.com/us/app/grow-life-fund/id6496204376', '_blank')} />
                        <GooglePlay width={60} height={22} className='w-[60px] cursor-pointer' onClick={() => window.open('https://play.google.com/store/apps/details?id=com.growlifefund&hl=en_IN', '_blank')} />
                    </div>
                </div>
                <img src={AppImage} alt="App" />
            </div>
        </div>
    )
}

export default AppPromo